'use strict';

angular.module('clientDashboardApp').factory('invoicingConfigService', function ($http) {

  return {
    get(billingAccountId) {
      return $http
        .get('/billingAccounts/invoicingConfig', {
          params: {
            billingAccountId
          }
        })
        .then(data => data.data)
    },

    getLastInvoice(billingAccountId) {
      return $http
        .get('/billingAccounts/lastInvoice', {
          params: {
            billingAccountId
          }
        })
        .then(data => data.data)
    },

    /**
     *
     * @param {number?} invoice_id
     * @param {number?} statement_id
     * @param {number?} locationBasedChargesCents
     * @param {number?} minimumDiffChargesCents
     * @returns {HttpPromise}
     */
    overrideInvoice({
      invoice_id,
      statement_id,
      locationBasedChargesCents,
      minimumDiffChargesCents
    }) {
      return $http
        .post("billingAccounts/overrideInvoice", {
          invoice_id,
          statement_id,
          locationBasedChargesCents,
          minimumDiffChargesCents
        })
    },

    syncNow({ billingAccountId }) {
      return $http
        .post("/billingAccounts/syncInvoice", undefined, {
          params: {
            billingAccountId
          }
        })
    },

    getBillingAccountLocations: (billingAccountId, excludeLocationId, generalTextMatch, limit) =>
      $http.get(`billingAccountLocations`, {
        params: {
          billingAccountId,
          limit,
          excludeLocationId,
          generalTextMatch,
        }
      })
      .then(data => data.data)
    ,

    save: (invoicingConfig) => $http.put('/billingAccounts/invoicingConfig', invoicingConfig),
  }
});
